<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="employee.FirstName + ' ' + employee.LastName + (employee.EmployeeNumber ? ' - '+employee.EmployeeNumber : '') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/employees`">
                            <i class="fa fa-group"></i> Employees
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        {{ employee.FirstName }} {{ employee.LastName }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12 mb-lg-2">
                    <div class="card">
                        <h6 class="card-header">
                            Employee details

                            <div class="float-sm-right mt-sm-0 mt-3">
                                <router-link :to="`/users/create?EmployeeId=${employee.EmployeeId}`" class="btn btn-sm btn-light" v-if="!employee.UserId && isAdmin">
                                    <i class="fa fa-user"></i> Create User
                                </router-link>
                                <router-link :to="`/employees/edit/${employee.EmployeeId}`" class="btn btn-sm btn-light" v-if="canEdit">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/employees/merge/${employee.EmployeeId}`" class="btn btn-sm btn-light" v-if="canEdit">
                                    <i class="fa fa-trash"></i> Merge & Delete
                                </router-link>
                            </div>
                        </h6>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">First Name:</div>
                                        <div class="col-md-8">{{ employee.FirstName }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Last Name:</div>
                                        <div class="col-md-8">{{ employee.LastName }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Middle Name:</div>
                                        <div class="col-md-8">{{ employee.middle_name }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Suffix:</div>
                                        <div class="col-md-8">{{ employee.suffix }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Employee#:</div>
                                        <div class="col-md-8">{{ employee.EmployeeNumber }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">SSN Last 4:</div>
                                        <div class="col-md-8">{{ employee.ssn_last_4 }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Primary Division:</div>
                                        <div class="col-md-8">
                                            <template>{{ employee.division_code }} - {{ employee.DivisionName }}</template>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="employee.other_divisions && employee.other_divisions.length > 0">
                                        <div class="col-md-4 text-muted">Other Division:</div>
                                        <div class="col-md-8">
                                            <div v-for="div in employee.other_divisions">{{ div.division_code }} - {{ div.DivisionName }}</div>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Current Jobsite:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/jobsites/view/${employee.current_jobsite_id}`" v-if="employee.current_jobsite_id">{{ employee.JobsiteNumber }} - {{ employee.JobsiteName }}</router-link>
                                            <div class="text-muted" title="Check In Timestamp" v-if="employee.current_jobsite_id && employee.last_checked_in_at">
                                                {{ employee.last_checked_in_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Trade:</div>
                                        <div class="col-md-8">{{ employee.trade }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Address:</div>
                                        <div class="col-md-8">
                                            {{ employee.Address }}<br v-if="employee.Address">
                                            {{ employee.City }}<span v-if="employee.City && employee.State">,</span> {{ employee.State }} {{ employee.Zip }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Temp Employee:</div>
                                        <div class="col-md-8">
                                            <label class="badge badge-success" v-if="employee.is_temp_employee == 1">Yes</label>
                                            <label class="badge badge-default" v-else>No</label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="employee.subcontractor_id">
                                        <div class="col-md-4 text-muted">Subcontractor:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/subcontractors/view/${employee.subcontractor_id}`">
                                                {{ employee.subcontractor_name }}
                                            </router-link>
                                            <template v-if="employee.tiered_sub_name"> - {{ employee.tiered_sub_name }}</template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Position:</div>
                                        <div class="col-md-8">{{ employee.position  }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Birthday:</div>
                                        <div class="col-md-8">{{ employee.BirthDate | moment("MM/DD/YYYY") }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Hire Date:</div>
                                        <div class="col-md-8"><span v-if="employee.HireDate">{{ employee.HireDate | moment("MM/DD/YYYY") }}</span></div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Last Rehire Date:</div>
                                        <div class="col-md-8"><span v-if="employee.last_rehire_date">{{ employee.last_rehire_date | moment("MM/DD/YYYY") }}</span></div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Weekly Salary:</div>
                                        <div class="col-md-8">{{ employee.WeeklySalary }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Phone:</div>
                                        <div class="col-md-8">
                                            {{ employee.Phone }}
                                            <label class="badge badge-success" v-if="employee.enable_text_blasts === 1">Text Enabled</label>
                                            <label class="badge badge-warning" v-else>Text Disabled</label>

                                            <label class="badge badge-danger" v-if="employee.opted_out_of_texts === 1">Opted Out</label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Email:</div>
                                        <div class="col-md-8">
                                            <a :href="`mailto:${employee.email}`" v-if="employee.email">{{ employee.email }}</a>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Gender:</div>
                                        <div class="col-md-8">
                                            {{ employee.gender }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Active:</div>
                                        <div class="col-md-8">
                                            <label class="badge badge-success" v-if="employee.IsActive == 1">Active</label>
                                            <label class="badge badge-warning" v-else>Inactive</label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Approved Driver:</div>
                                        <div class="col-md-8">
                                            <label class="badge badge-success" v-if="employee.driver_status_id == 1">{{ employee.driver_status_name }}</label>
                                            <label class="badge badge-warning" v-else-if="employee.driver_status_id == 2">{{ employee.driver_status_name }}</label>
                                            <label class="badge badge-info" v-else-if="employee.driver_status_id">{{ employee.driver_status_name }}</label>
                                            <span v-else>--</span>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted">Linked User:</div>
                                        <div class="col-md-8">
                                            <template v-if="user">
                                                <router-link :to="`/users/view/${user.UserId}`" title="View User Record">
                                                    {{ user.FirstName }} {{ user.LastName }}
                                                </router-link><br>
                                                {{ user.email }}
                                            </template>
                                            <template v-else>
                                                <p>-- No Associated User --</p>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4" v-if="sections && sections.length > 0">
                        <incident-sections-view :sections="sections"></incident-sections-view>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-header">Public Profile QR Code <i class="fa fa-question-circle" title="Use this to create a scannable barcode that links back to this employee page. This can be printed and displayed where easily accessible."></i></div>
                        <div class="card-body" style="overflow-x: auto;">
                            <b-input-group class="mb-2">
                                <template #prepend>
                                    <b-input-group-text class="bg-light">Size</b-input-group-text>
                                </template>
                                <b-form-select v-model="qr_code_size" :options="qrCodeOptions"></b-form-select>
                            </b-input-group>

                            <span v-show="qr_loading"><i class="fa fa-spin fa-spinner"></i></span>

                            <div v-show="!qr_loading">
                                <img :src="`data:image/png;base64,${qr_code_html}`" />
                            </div>

                            <div class="mt-2" v-if="employee.emp_key">
                                <a :href="`/employees/public/${employee.emp_key}`" target="_blank">View Public Profile</a>
                            </div>
                            <div class="mt-2">
                                <a :href="`/employees/qr-code/${employee.EmployeeId}?download=true&qr_code_size=${qr_code_size}&show_name=${show_name}&show_number=${show_number}`" target="_blank">Download QR Code</a>

                                <b-form-checkbox v-model="show_name" :value="true" :unchecked-value="false" plain> Include Employee Name on Label</b-form-checkbox>
                                <b-form-checkbox v-model="show_number" :value="true" :unchecked-value="false" plain> Include Employee# on Label</b-form-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            Emergency Contacts ({{ contacts.length }})

                            <div class="float-sm-right mt-sm-0 mt-3" v-if="canEdit">
                                <button type="button" v-on:click="add_edit_contact_modal = !add_edit_contact_modal" class="btn btn-sm btn-light">
                                    <i class="fa fa-plus-circle"></i> Add
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-for="contact in contacts" class="mb-3">
                                <div>
                                    {{ contact.contact_name }} <span class="text-muted" v-if="contact.contact_relationship">, {{ contact.contact_relationship }}</span>
                                    <a href="javascript:void(0)" v-on:click="editContact(contact)" title="Edit Emergency Contact" v-if="canEdit"><i class="fa fa-edit"></i></a>
                                    <a href="javascript:void(0)" v-on:click="deleteContact(contact)" title="Delete Emergency Contact" v-if="canEdit" class="text-danger"><i class="fa fa-trash"></i></a>
                                </div>
                                <div v-if="contact.contact_phone">
                                    <i class="fa fa-phone"></i> <a :href="`tel:${contact.contact_phone}`">{{ contact.contact_phone }}</a>
                                </div>
                                <div v-if="contact.contact_email">
                                    <i class="fa fa-envelope"></i> <a :href="`mailto:${contact.contact_email}`">{{ contact.contact_email }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                    <i class="fa fa-list"></i> Inspections <template v-if="inspectionCount != null">({{ inspectionCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                    <i class="fa fa-stethoscope"></i> Incidents <template v-if="incidentCount != null">({{ incidentCount }})</template>
                </b-nav-item>

                <b-nav-item :active="curTab === 'equipment'" @click="curTab = 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                    <i class="fa fa-truck"></i> Equipment <template v-if="equipmentCount != null">({{ equipmentCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'jobsites'" @click="curTab = 'jobsites'" v-if="this.$root.hasPermission('jobsites.view')">
                    <i class="fa fa-building"></i> Jobsites <span v-if="jobsiteCount">({{ jobsiteCount }})</span>
                </b-nav-item>
                <b-nav-item :active="curTab === 'jsa'" @click="curTab = 'jsa'" v-if="this.$root.hasPermission('jsa.view.browse')">
                    <i class="fa fa-files-o"></i> JSAs
                </b-nav-item>


                <!-- <b-nav-item :active="curTab === 'recognitions'" @click="curTab = 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                    <i class="fa fa-trophy"></i> Recognitions
                </b-nav-item>
                <b-nav-item :active="curTab === 'disc_actions'" @click="curTab = 'disc_actions'" v-if="this.$root.hasPermission('employees.disciplinary.view')">
                    <i class="fa fa-gavel"></i> Disciplinary
                </b-nav-item> -->

                <b-nav-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                    <i class="fa fa-life-ring"></i> Safety Meetings
                </b-nav-item>
                <b-nav-item :active="curTab === 'training_courses'" @click="curTab = 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view.employees'])">
                    <i class="fa fa-graduation-cap"></i> Training Courses
                </b-nav-item>

                <b-nav-item-dropdown
                    :active="curTab === 'gavel' || curTab === 'trophy' || curTab === 'custom_forms'"
                    right
                    title="More Employee Resources: JSAs, Equipment, Etc."
                    v-if="this.$root.hasPermission(['equipment.view', 'jsa.view.browse'])">
                    <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="curTab = 'disc_actions'" v-if="this.$root.hasPermission('employees.disciplinary.view')">
                        <i class="fa fa-gavel"></i> Disciplinary Actions
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <i class="fa fa-trophy"></i> Recognitions
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission(['custom_forms.view'])">
                        <i class="fa fa-check-square-o"></i> Custom Forms
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="getTabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                        <i class="fa fa-list"></i> Inspections <template v-if="inspectionCount != null">({{ inspectionCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <i class="fa fa-stethoscope"></i> Incidents <template v-if="incidentCount != null">({{ incidentCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'equipment'" @click="curTab = 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                        <i class="fa fa-truck"></i> Equipment <template v-if="equipmentCount != null">({{ equipmentCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'jobsites'" @click="curTab = 'jobsites'" v-if="this.$root.hasPermission('jobsites.view')">
                        <i class="fa fa-building"></i> Jobsites <span v-if="jobsiteCount">({{ jobsiteCount }})</span>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'jsa'" @click="curTab = 'jsa'" v-if="this.$root.hasPermission(['jsa.view.browse'])">
                        <i class="fa fa-files-o"></i> JSAs
                    </b-dropdown-item>

                    <b-dropdown-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <i class="fa fa-life-ring"></i> Safety Meetings
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'training_courses'" @click="curTab = 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view.employees'])">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'disc_actions'" @click="curTab = 'disc_actions'" v-if="this.$root.hasPermission('employees.disciplinary.view')">
                        <i class="fa fa-gavel"></i> Disciplinary Actions
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'recognitions'" @click="curTab = 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <i class="fa fa-trophy"></i> Recognitions
                    </b-dropdown-item>

                    <b-dropdown-item :active="curTab === 'custom_forms'" @click="curTab = 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission('custom_forms.view')">
                        <i class="fa fa-check-square-o"></i> Custom Forms <span v-if="customFormCount">({{ customFormCount }})</span>
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="card">
                <div class="card-body">
                    <div v-show="curTab === 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                        <inspection-list assetType="Employee" :assetId="parseInt(EmployeeId)" @inspectionListCount="inspectionListCount" />
                    </div>
                    <div v-show="curTab === 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <incident-list assetType="Employee" :assetId="parseInt(EmployeeId)" @incidentListCount="incidentListCount" />
                    </div>
                    <div v-show="curTab === 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <employee-recognition-list :assetId="this.employee.EmployeeId" assetType="Employee" />
                    </div>
                    <div v-show="curTab === 'disc_actions'" v-if="this.$root.hasPermission('employees.disciplinary.view')">
                        <disciplinary-list :employee_id="parseInt(this.EmployeeId)" />
                    </div>
                    <div v-show="curTab === 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <safety-meeting-list assetType="Employee" :assetId="EmployeeId" />
                    </div>
                    <div v-show="curTab === 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view.employees'])">
                        <employee-training-list :employeeId="parseInt(EmployeeId)" :showAddButton="true" :showDistributeButton="true" :courseType="'Employee'"></employee-training-list>
                    </div>
                    <div v-show="curTab === 'jsa'" v-if="this.$root.hasPermission(['jsa.view.browse'])">
                        <jsa-employee-list :employee_id="employee.EmployeeId" />
                    </div>
                    <div v-show="curTab === 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                        <equipment-list assetType="Employee" :assetId="employee.EmployeeId" @equipmentListCount="equipmentListCount" />
                    </div>
                    <div v-show="curTab === 'jobsites'" v-if="this.$root.hasPermission('jobsites.view')">
                        <jobsite-list assetType="Employee" :assetId="employee.EmployeeId" @jobsiteListCount="((count) => { jobsiteCount = count; })" />
                    </div>
                    <div v-show="curTab === 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission('custom_forms.view')">
                        <covid-list :employee_id="employee.EmployeeId" @customFormListCount="((count) => { customFormCount = count; })" />
                    </div>
                </div>
            </div>

        </div>

        <b-modal
            v-model="add_edit_contact_modal"
            :title="(add_edit_contact.id ? 'Edit' : 'New') + ' Emergency Contact'"
            size="lg"
            :ok-title="(add_edit_contact.id ? 'Update' : 'Create') + ' Emergency Contact'"
            ok-variant="success"
            :ok-disabled="saving_emergency_contact"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="saveContact"
            ref="emergecyContactModal"
            :no-close-on-backdrop="true"
            scrollable>
            <div class="form-horizontal">
                <div class="form-group row mb-2">
                    <label class="col-md-3 col-form-label text-md-right" :class="{'text-danger': errors.contact_name, 'text-muted': !errors.contact_name}">
                        Contact Name: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-6">
                        <b-form-input v-model="add_edit_contact.contact_name" size="sm" placeholder="Enter Contact Name" :class="{'is-invalid': errors.contact_name}" />

                        <span v-if="errors.contact_name" class="text-danger">
                            <span v-for="error in errors.contact_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row mb-2">
                    <label class="col-md-3 col-form-label text-md-right" :class="{'text-danger': errors.contact_phone, 'text-muted': !errors.contact_phone}">
                        Contact Phone: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-6">
                        <b-form-input v-model="add_edit_contact.contact_phone" size="sm" placeholder="Enter Contact Phone" :class="{'is-invalid': errors.contact_phone}" />

                        <span v-if="errors.contact_phone" class="text-danger">
                            <span v-for="error in errors.contact_phone">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row mb-2">
                    <label class="col-md-3 col-form-label text-md-right" :class="{'text-danger': errors.contact_email, 'text-muted': !errors.contact_email}">
                        Contact Email: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-6">
                        <b-form-input v-model="add_edit_contact.contact_email" size="sm" placeholder="Enter Contact Email" :class="{'is-invalid': errors.contact_email}" />

                        <span v-if="errors.contact_email" class="text-danger">
                            <span v-for="error in errors.contact_email">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row mb-2">
                    <label class="col-md-3 col-form-label text-md-right" :class="{'text-danger': errors.contact_relationship, 'text-muted': !errors.contact_relationship}">
                        Contact Relationship:
                    </label>
                    <div class="col-md-6">
                        <b-form-input v-model="add_edit_contact.contact_relationship" size="sm" placeholder="Enter Relationship: Father, Mother, Wife, etc." :class="{'is-invalid': errors.contact_relationship}" />

                        <span v-if="errors.BirthDate" class="text-danger">
                            <span v-for="error in errors.contact_relationship">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                loading: true,
                qr_loading: false,
                EmployeeId: this.$route.params.id,
                curTab: 'inspections',
                employee: {},
                user: null,
                errors: {},
                sections: [],
                show_name: false,
                show_number: false,
                inspectionCount: null,
                incidentCount: null,
                equipmentCount: null,
                jobsiteCount: null,
                customFormCount: null,

                //Emergency Contacts
                add_edit_contact_modal: false,
                saving_emergency_contact: false,
                add_edit_contact: {},
                contacts: [],

                columns: ['supervisor_name', 'JobsiteName', 'DivisionName', 'recognition_date', 'explanation'],
                options: {
                    headings: {
                        supervisor_name: 'Supervisor',
                        JobsiteName: 'Jobsite',
                        DivisionName: 'Division',
                        recognition_date: 'Date',
                        explanation: 'Explanation',
                    }
                },
                roles: [],
                qr_code_size: 5,
                qr_code_html: null,
                qrCodeOptions: [
                    {value: 3, text: '87x87'},
                    {value: 4, text: '116x116'},
                    {value: 5, text: '145x145'},
                    {value: 6, text: '174x174'},
                    {value: 7, text: '203x203'},
                    {value: 8, text: '232x232'},
                    {value: 9, text: '261x261'},
                ],
            }
        },

        watch: {
            qr_code_size(newVal, oldVal){
                //Get the QR Code
                this.getQrCode();
            },
        },

        computed: {

            isAdmin(){
                return this.$store.state.user.is_admin
            },

            canEdit(){
                return this.$root.hasPermission('employees.manage');
            },

            getTabTitle(){
                //Setup
                var title = '';
                var icon = 'bars';

                //Switch
                switch(this.curTab)
                {
                    case 'incidents':
                        //Set
                        title = 'Incidents';
                        icon = 'stethoscope';
                        break;
                    case 'recognitions':
                        //Set
                        title = 'Recognitions';
                        icon = 'trophy';
                        break;
                    case 'equipment':
                        //Set
                        title = 'Equipment';
                        icon = 'truck';
                        break;
                    case 'jsa':
                        //Set
                        title = 'JSAs';
                        icon = 'file-o';
                        break;
                    case 'meetings':
                        //Set
                        title = 'Safety Meetings';
                        icon = 'life-ring';
                        break;
                    case 'disc_actions':
                        //Set
                        title = 'Disciplinary Actions';
                        icon = 'gavel';
                        break;
                    case 'training_courses':
                        //Set
                        title = 'Training Courses';
                        icon = 'graduation-cap';
                        break;
                }

                //Send it
                return '<i class="fa fa-'+icon+'"></i> ' + title;
            }

        },

        methods: {
            getEmployee() {
                //Get the data
                this.$http
                    .get('employees/view/' + this.EmployeeId)
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.user = response.data.user;
                        this.contacts = response.data.contacts;
                        this.sections = response.data.sections;

                        //Set loading
                        this.loading = false;

                        //Get the QR Code
                        this.getQrCode();
                    })
                    .catch(response => {

                    });
            },

            getQrCode(){
                //QR Code
                this.qr_loading = true;

                //Get the data
                this.$http
                    .get('employees/qr-code/' + this.EmployeeId, {qr_code_size: this.qr_code_size})
                    .then(response => {
                        //Set all the data
                        this.qr_code_html = response.data.qr_code;
                        this.employee.emp_key = response.data.emp_key;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.qr_loading = false;
                    });
            },

            inspectionListCount(count){
                //SEt it
                this.inspectionCount = count;
            },

            incidentListCount(count){
                //Set it
                this.incidentCount = count;
            },

            equipmentListCount(count){
                //Set the count
                this.equipmentCount = count;
            },

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.add_edit_contact = {};
                this.errors = {};
            },

            editContact(contact){
                //Reset the values
                this.add_edit_contact = contact;
                this.add_edit_contact_modal = true;
            },

            deleteContact(contact){
                //Confirm
                if(!confirm('Are you sure you want to delete this Emergency Contact?'))
                {
                    return false;
                }

                //Send it
                this.$http
                    .delete('employees/emergency-contact/'+contact.id)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Emergency Contact Deleted');

                        //Rplace it
                        for (var i = 0; i < this.contacts.length; i++)
                        {
                            //Check the ID
                            if(this.contacts[i].id == contact.id)
                            {
                                //Splice it
                                this.contacts.splice(i, 1);
                            }
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {

                    });
            },

            saveContact(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?
               this.saving_emergency_contact = true;

               //Set Employee ID
               this.add_edit_contact.employee_id = this.employee.EmployeeId;

               //Send it
               this.$http
                   .post('employees/emergency-contact', this.add_edit_contact)
                   .then(response => {
                       //Alert the user?
                       this.$toastr.success('Emergency Contact Saved');

                       //Update the Contacts
                       if(this.add_edit_contact.id)
                       {
                            //Rplace it
                            for (var i = 0; i < this.contacts.length; i++)
                            {
                                //Check the ID
                                if(this.contacts[i].id == response.data.id)
                                {
                                    //Splice it
                                    this.contacts.splice(i, 1, response.data);
                                }
                            }
                       }
                       else
                       {
                            //Push it
                            this.contacts.push(response.data);
                       }

                       //Reset and close
                       this.add_edit_contact_modal = false;
                       this.add_edit_contact = {};
                   })
                   .catch(error => {
                        //Validation Errors
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                   })
                   .then(() => {
                       //Set loading
                       this.saving_emergency_contact = false;
                   });
            },
        },
        mounted() {
            //Get the employee
            this.getEmployee();
        }
    }
</script>
